export const start = async function() {
    await setTimeout(async () => {
        var videoStartBtn = document.getElementsByClassName("videoButton");
        videoStartBtn[0].addEventListener('click', videoStarter);
    }, 50)
}

// shared functions

var videoStarter = function(_e) {
    var video = document.getElementById("mainVideo");
    var image = document.getElementById("imageBanner");

    image.classList.add("faded");
    video.play();

    var videoStartBtn = document.getElementsByClassName("videoButton");
    videoStartBtn[0].style.opacity = 0;
}

export const stop = async function() {
    var videoStartBtn = document.getElementsByClassName("videoButton");
    var image = document.getElementById("imageBanner");
    image.classList.remove("faded");
    videoStartBtn[0].removeEventListener('click', videoStarter);
}
